/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scan_ChickenInputs */

const en_portal_scan_chicken = /** @type {(inputs: Portal_Scan_ChickenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chicken 180 g`)
};

const pl_portal_scan_chicken = /** @type {(inputs: Portal_Scan_ChickenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurczak 180 g`)
};

/**
* | output |
* | --- |
* | "Chicken 180 g" |
*
* @param {Portal_Scan_ChickenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_scan_chicken = /** @type {((inputs?: Portal_Scan_ChickenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scan_ChickenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_scan_chicken(inputs)
	return en_portal_scan_chicken(inputs)
});